import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppReady } from '@rd/app-init/app-init.action';
import { PaymentGatewayService } from '@rd/core/services/payment-gateway/payment-gateway.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class PaymentInitEffects {
  constructor(
    private actions$: Actions,
    private paymentGatewayService: PaymentGatewayService,
  ) {}

  initializeStripe$ = createEffect(
    () =>
      this.actions$.pipe(ofType(AppReady)).pipe(
        tap(() => {
          this.paymentGatewayService.loadScript();
        }),
      ),
    {
      dispatch: false,
    },
  );
}
